exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-1f8a88e5] .v-datatable.v-table>thead{display:table-header-group}[data-v-1f8a88e5] .v-datatable.v-table>tbody{display:table-row-group}", ""]);

// exports
